import * as React from 'react';
import PaymentRequestPageView from '../layouts/PaymentPageView';
import { PaymentData } from 'src/reducers/payment';

export interface PaymentRequestPageProps {
  onComponentDidMount: () => void;
  paymentData: PaymentData[];
  details: (total: number, tableData: PaymentData[] | PaymentData) => void;
  isWaiting: boolean;
  paymentId: string;
  // paymentAmount: (amount: number) => void;
  // unitTotal: (units: number) => void;
  paymentCall: (amount: number) => void;
  // totalAmount: number;
  // totalUnits: number;
  isWaitingClose: () => void;
  reload: () => void;

  fDate: (fromDate: Date | null) => void;
  toDate: (todate: Date | null) => void;

  startDate: Date | null;
  endDate: Date | null;

  dateFilter: () => void;
  dateReset: () => void;
  printTxn: (txn: String) => void;
}

class PaymentRequestPage extends React.Component<PaymentRequestPageProps> {
  render() {
    return (
      <div>
        <PaymentRequestPageView
          paymentData={this.props.paymentData}
          details={this.props.details}
          isWaiting={this.props.isWaiting}
          paymentId={this.props.paymentId}
          // paymentAmount={this.props.paymentAmount}
          paymentCall={this.props.paymentCall}
          // totalAmount={this.props.totalAmount}
          // unitTotal={this.props.unitTotal}
          // totalUnits={this.props.totalUnits}
          isWaitingClose={this.props.isWaitingClose}
          reload={this.props.reload}
          fDate={this.props.fDate}
          toDate={this.props.toDate}
          startDate={this.props.startDate}
          endDate={this.props.endDate}
          dateFilter={this.props.dateFilter}
          dateReset={this.props.dateReset}
          printTxn={this.props.printTxn}
          
        />
      </div>
    );
  }
  componentDidMount() {
    this.props.onComponentDidMount();
  }
}

export default PaymentRequestPage;



// WEBPACK FOOTER //
// ./src/components/PaymentRequest/PaymentRequestPage.tsx